import $ from 'jquery';

export default () => {
    const header = $('.js-site-header');
    const trigger = $('.js-site-header-trigger');
    const nav = $('.js-site-nav');
    const subNavTrigger = nav.find('a[href="#"]');
    const siteContent = $('.js-site-content');
    const hero = $('.js-hero');
    const heroVideo = $('.js-hero-video');
    let headerHeight = header.outerHeight() / 16;

    const headroom = new Headroom(header[0], {
        offset: header.outerHeight()
    });
    headroom.init();

    siteContent.css('paddingTop', headerHeight + 'rem');

    $(window).on('resize', function() {
        headerHeight = header.outerHeight() / 16;

        siteContent.css('paddingTop', headerHeight + 'rem');

        if (hero.hasClass('has-video')) {
            if ($(window).width() >= 900) {
                hero.css('height', 'calc(100vh - '+headerHeight+'rem)');

                const heroHeight = hero.outerHeight();
                const heroWidth = hero.outerWidth();
                const heroRatio = heroHeight / heroWidth;
                const goldenRatio = 9 / 16;

                if (heroRatio < goldenRatio) {
                    heroVideo.css('width', heroWidth);
                } else {
                    heroVideo.css('width', hero.outerHeight() *16/9);
                }
            } else {
                hero.css('height', 'auto');
            }
        }
    });

    trigger.on('click', function() {
        $(this).add(nav).toggleClass('is-active');
    });

    subNavTrigger.on('click', function() {
        $(this).next().toggleClass('is-open');
        nav.toggleClass('is-sub-open');
    });

    if (hero.hasClass('has-video') && $(window).width() >= 900) {
        hero.css('height', 'calc(100vh - '+headerHeight+'rem)');
        heroVideo.css('width', hero.outerHeight() *16/9);
    }

    $(window).on('load', function() {
        hero.addClass('is-loaded');
    });
}



// WEBPACK FOOTER //
// ../src/scripts/modules/header.js